import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const Contact = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        background: "#f4f6f8",
        minHeight: "100vh",
        padding: "40px 0",
      }}
    >
      <div
        style={{
          maxWidth: "800px",
          margin: "auto",
          background: "#fff",
          borderRadius: "12px",
          padding: "40px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        }}
      >
        {/* Back Button */}
        <button
          className="btn btn-md d-flex align-items-center gap-2 fw-bold text-muted border-0 bg-transparent mb-3"
          onClick={() => navigate("/")}
        >
          <FaArrowLeft /> Back
        </button>

        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <span
            style={{
              background: "#e6f4f1",
              color: "#097969",
              padding: "6px 14px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: "600",
            }}
          >
            SUPPORT
          </span>

          <h1 style={{ color: "#097969", marginTop: "10px" }}>
            Contact Us
          </h1>

          <p style={{ color: "#666" }}>
            We’re here to help you
          </p>
        </div>

        <hr />

        {/* Intro */}
        <p style={{ marginTop: "20px", color: "#444", textAlign: "center" }}>
          Have questions about orders, uniforms, or delivery?  
          Reach out to <b>Shreenath NX</b> anytime.
        </p>

        {/* Contact Details */}
        <div style={{ marginTop: "30px", lineHeight: "2" }}>
          <p><b>Email:</b> nxshreenath@gmail.com</p>
          <p><b>Phone:</b> +91 9712586101</p>
          <p><b>Address:</b> Ahmedabad, Gujarat, India</p>
        </div>

      </div>
    </div>
  );
};

export default Contact;